// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1847":"321c9967","3562":"15d9b663","4181":"b8aa5897","5523":"e06c422c","7462":"25957f48","8012":"c9b72f2c","8136":"3da4dcc0"}[chunkId] + ".chunk.css";
};